<span class="sc-icon" [id]="id" [ngClass]="classes"></span>